module.exports = __webpack_public_path__ + "img/tg_cl.a14dd895.png";